export const POST_AUTH_CODE = 'POST_AUTH_CODE';

export const postAuthCode = (data) => ({
	type: POST_AUTH_CODE,
	data
});